import {
    MapIcon,
    SatelliteAltIcon,
} from "@l2r-front/l2r-icons"

import { default as planBackground } from "../assets/planBackground.png"
import { default as satelliteBackground } from "../assets/satelliteBackground.png"

export const MapStyles = {
    plan: {
        background: planBackground,
        color: "objects/object-lightgrey",
        contrastColor: "objects/object-black",
        icon: SatelliteAltIcon,
        mapStyle: "mapbox://styles/jteyssandier/clav74muv004r14n9iowbjqng",
        name: "Monochrome",
    },
    satellite: {
        background: satelliteBackground,
        color: "objects/object-black",
        contrastColor: "surfaces/surface-primary",
        icon: MapIcon,
        mapStyle: "mapbox://styles/jteyssandier/clb2e2obn000c15njpiw2suvr",
        name: "Satellite Streets",
    },
}

export const IMAGE_COLLECTION_TYPE_STREETVIEW = "STREETVIEW"
export const IMAGE_COLLECTION_TYPE_PHOTO = "PHOTO"